module.exports = __webpack_public_path__ + "static/media/36 - Nino Ferrer - Looking For You.533c245b.mp3";